/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./pollyfill');

import Vue from 'vue';
import router from './router';
import store from './store';
import vmodal from 'vue-js-modal';
import AppButton from './components/AppButton.vue';
import { titleCase } from './lib/string';
import getEnvironment from "./lib/getEnvironment";

Vue.use(require('vue-moment'));
Vue.use(vmodal, { dynamic: true, dialog: true });
Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('AppButton', AppButton);

/**
 * Search for Vue components in ./components and register them dynamically
 */
function loadVueComponents() {
    const requireComponent = require.context(
        // The relative path of the components folder
        './pages',
        // Whether or not to look in subfolders
        true,
        // The regular expression used to match base component filenames
        /.*[A-Z]\w+\.(vue|js|ts)$/,
    );

    for (const fileName of requireComponent.keys()) {
        const componentConfig = requireComponent(fileName);

        // Get PascalCase name of component
        const componentName = titleCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'));

        // Register component globally
        Vue.component(
            componentName,
            // Look for the component options on `.default`, which will
            // exist if the component was exported with `export default`,
            // otherwise fall back to module's root.
            componentConfig.default || componentConfig,
        );
    }
}

/**
 * Load Vue instances with the proper configuration as defined by the internal constant instances.
 *
 * Key corresponds to the global where the instance should be mounted.
 * Value corresponds to the configuration passed into Vue's constructor.
 */
function loadVueInstances() {
    const instances = {
        JobscanApp: { el: '#JobscanApp', router, store },
    };

    for (const [globalName, options] of Object.entries(instances)) {
        const id = options.el.slice(1);
        if (document.getElementById(id)) {
            (window as any)[globalName] = new Vue(options);
        }
    }
}

// Start Vue
loadVueComponents();
loadVueInstances();
